"use client";

import {
  Button,
  ModalContainer,
  ModalContent,
  Typography,
  useMediaQuery,
} from "@kyan/ui";
import { useState } from "react";

import { RefCodeInput } from "#/components/RefCodeInput/RefCodeInput";
import { useAccount } from "#/store/wallet/account/account";

export const RedeemReferralCode: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { isAccountConnected } = useAccount();
  const { isSm } = useMediaQuery();

  return (
    <>
      <Button
        size="lg"
        className="h-12.5"
        variant="secondary"
        disabled={!isAccountConnected}
        onClick={() => setOpen(true)}
      >
        {isSm ? "Enter referral code" : "Referral code"}
      </Button>

      <ModalContainer open={open} onOpenChange={setOpen}>
        <ModalContent
          shouldScroll={false}
          headerClassName="flex flex-col gap-4"
          description="If you've received a referral code, input it here"
          header={
            <Typography medium grotesk primary element="h2">
              Referral code
            </Typography>
          }
        >
          <RefCodeInput
            className="pt-5"
            variant="standalone"
            onSuccess={() => setOpen(false)}
          />
        </ModalContent>
      </ModalContainer>
    </>
  );
};
